<ng-container *ngIf="scenarioEx && scenarioEx?.rows?.length > 0">

    <app-grid-scenario [columns]="columns" [rows]="scenarioEx.rows" (activate)="dlgTransac($event)">
    </app-grid-scenario>

</ng-container>